import { Button, ConfirmationPopup, Icon, Select, SuccessModal, Loader } from '@ohif/ui';
import RichTextEditor from '../../../../platform/custom/Reports/RichTextEditor';
import React, { useEffect, useRef, useState } from 'react';
import { getEnabledElement as OHIFgetEnabledElement } from './../../../../extensions/cornerstone/src';
import { servicesManager } from './../../../../platform/app/src/App';
import { changeReportPriority, createNewReport, getCurrentReport } from '../../../../platform/custom/Apis/apis';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { _reportStatus, _roleType } from '@custom/Utils/constants/appConstants';
import SpeechToText from '@custom/Common/SpeechToText';
import { useSelector, useDispatch } from 'react-redux';

import { PACS_URL } from '@custom/constant';
import uploadReportImgs from '@custom/rtk-apis/report/uploadReportImgs';
import patientDetails from '@custom/rtk-apis/patients/patientDetails';
import { AppDispatch, RootState } from '@custom/store/store';
import redoScan from '@custom/rtk-apis/redo/redoScan';
import addRedoReason from '@custom/rtk-apis/redo/addReason';
import { closeModal } from '@custom/store/slices/redo/addReason';
import { closeModal as redoCloseModal } from '@custom/store/slices/redo/redoScan';
import { getCloudPACSToken } from '@custom/Utils/authUtils';
import { capitalizeWords } from '@custom/Utils/utils';

import './index.css';
import hospitalDetailApi from '@custom/rtk-apis/hospital/hospitalDetails';
import userDetails from '@custom/rtk-apis/user/userDetails';
import { _deleteDicomUrl } from '@custom/Utils/constants/apiUrls';

const ReportLayout = ({ selectedTempleate, setSelectedTempleate, setOpenReportPanel, selectedTemplateName, reportStatus, reportId, setReportId, comment, isPathology, imageBlob, templateID, getCurrRep, actionType }) => {

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const reportImageSelector = useSelector((state: RootState) => state.reportImageSelector);
  const uploadReportImgsResponse = useSelector((state: RootState) => state.uploadReportImgsResponse);
  const patientData = useSelector((state: RootState) => state.patientdetailResponce);
  const redoScanData = useSelector((state: RootState) => state.redoScanSliceResponse);
  const addRedoReasonData = useSelector((state: RootState) => state.addRedoReasonResponse);

  const { uiNotificationService } = servicesManager.services
  const url = `http://44.198.48.187:8081`//`https://6vgc6mbq-8081.inc1.devtunnels.ms` //http://localhost:8081
  const role = sessionStorage.getItem('role') || localStorage.getItem('role');
  const isSharedLink = sessionStorage.getItem('shareAuthToken') !== null || localStorage.getItem('shareAuthToken') !== null;

  /* Width of the report panel. By default, it is set to 550px. */
  const [width, setWidth] = useState(550);

  const [modal, setModal] = useState(false);
  const [isPopupOpen, setAuthorizedPopup] = useState(false)
  const [reportData, setReportData] = useState("")
  const [selectedReportStatus, setSelectedReport] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [currentReportImageLink, setCurrentReportImageLink] = useState([])
  const [patientID, setPatientID] = useState('');
  const [reportID, setReportID] = useState('');
  const [patientName, setPatientName] = useState('');
  const [isPopupRedoOpen, setIsPopupRedoOpen] = useState(false);
  const [isRedoLoading, setIsRedoLoading] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [displayMessage, setDisplayMessage] = useState('');
  const [reason, setReason] = useState('');
  const [isRedoReasonCalled, setIsRedoReasonCalled] = useState(false);
  const [impressions, setImpressions] = useState('');
  const [currentReportId, setCurrentReportId] = useState(reportId);
  const [errorMessage, setErrorMessage] = useState('');

  /**
   * Handles the mouse down event on the report panel resize handle.
   *
   * @param {MouseEvent} e - The mouse event object.
   */
  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    const startX = e.clientX;
    const startWidth = width;

    /**
     * Handles the mouse move event during the report panel resize.
     *
     * @param {MouseEvent} e - The mouse event object.
     */
    const onMouseMove = (e: MouseEvent) => {
      const newWidth = startWidth - (e.clientX - startX);
      setWidth(newWidth > 0 ? newWidth : 0); // Ensure width is not negative
    };

    /**
     * Handles the mouse up event after the report panel resize is finished.
     * Removes the event listeners for mouse move and mouse up.
     */
    const onMouseUp = () => {
      // Remove the event listeners for mouse move and mouse up
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const createPathologyReport = async (selectedHTML, status, comment, updatedImpressions, buttonClick=false) => {
    const url = window.location.href;
    const segments = new URL(url).pathname.split('/');
    const WSIID = segments[segments.length - 1]; // Get the last segment
    const patientUID = segments[segments.length - 2];

    if (!(WSIID && (patientUID == patientData?.result.patientDetails.UHID))) {
      return null;
    }

    let imgUrls = currentReportImageLink || [];

    if (imageBlob != null) {
      const formData = new FormData();
      formData.append('file', imageBlob, 'image.png')

      try {
        const response = await dispatch(uploadReportImgs(formData));

        if (response?.meta?.requestStatus === 'fulfilled') {

          if (response?.payload?.status === 'SUCCESS') {
            imgUrls = [...imgUrls, ...response?.payload?.results?.map((item) => {
              return item?.result;
            })]
          }

        } else {
          console.error('API request failed:', response.error); // Handle failure
        }
      } catch (error) {
        console.error('Error in dispatch:', error); // Handle any dispatch errors
      }
    }
    const now = Date.now();
    const currentDate = new Date(now);
    // Get the date in YYYY-MM-DD format
    const date = currentDate.toISOString().split('T')[0];

    // Get the time in HH:MM:SS format
    const time = currentDate.toTimeString().split(' ')[0];
    const payload = {
      htmlTemplate: selectedHTML,
      editorMode: selectedTempleate?.editorMode,
      patientName: `${patientData?.result?.patientDetails?.firstName} ${patientData?.result?.patientDetails?.lastName}`,
      patientGender: patientData?.result?.patientDetails?.gender,
      reportName: selectedTemplateName,
      patientAge: calculateAge(patientData?.result?.patientDetails?.dob),
      patientID: patientData?.result.patientDetails.patientId,
      uhid: patientData?.result.patientDetails.UHID,
      date,
      time,
      //studyInstanceUID,
      wsiID: WSIID,
      status: status,//status.value,
      images: imgUrls || [],
      modality: selectedTempleate?.modality,
      comment: comment,
      impressions: impressions,
      templateId: templateID,
    };
    if (actionType === 'view') {
      payload['templateId'] = selectedTempleate?.templateId;
    }
    if (reportId || currentReportId) {
      console.log("reportId", reportId || currentReportId)
      payload["_id"] = reportId || currentReportId
    }
    try {
      const response = await createNewReport(payload);
      console.log("response update new report", response)
      setCurrentReportId(response?.result?.id)
      if (response.status == 'SUCCESS') {
        if(buttonClick){
          setModal(true);
        } else {
          uiNotificationService.show({
            title: 'Success',
            message:
              response?.msg || "Report created successfully",
            type: 'success',
            duration: 3000,
            position: 'topRight',
          });
        }
        setTimeout(() => {
          if (status === 'Authorized') {
            navigate(`/report/preview/${reportId || currentReportId}`)
          }
          else {
            if(buttonClick){
              navigate("/reportlist")
            }
          }
        }, 2000);
      }
      else {
        uiNotificationService.show({
          title: 'Error',
          message:
            response?.msg || "Error occured",
          type: 'error',
          duration: 3000,
          position: 'topRight',
        });
      }
    } catch (err) {
      console.error("Something went wrong while saving report ", err);
    }
  }

  // Custom state
  const [status, setStatus] = useState({
    label: reportStatus || _reportStatus.Draft,
    value: reportStatus || _reportStatus.Draft
  })

  const handleCreateReport = async (selectedHTML, status, comment, updatedImpressions, buttonClick=false) => {
    const formattedStatus = capitalizeWords(status);
    setStatus({
      label: formattedStatus,
      value: formattedStatus
    });
    if(buttonClick){
      setIsLoading(true);
    }
    try {
      if (status === 'Authorized') {
        setAuthorizedPopup(true);
        setReportData(selectedHTML);
        setSelectedReport(formattedStatus);
      }
      if (isPathology) {
        await createPathologyReport(selectedHTML, status, comment, updatedImpressions, buttonClick);
      } else if (getCurrRep !== 0 && status !== 'Authorized') {
        await updateReportStatus(selectedHTML, formattedStatus, comment, updatedImpressions, buttonClick);
      }
    } catch (error) {
      console.error('Error updating report status:', error);
    } finally {
      if(buttonClick){
        setIsLoading(false);
      }
    }
  };

  const base64ToBlob = (base64, type = 'image/png') => {
    const prefix = 'data:image/png;base64,';
    if (base64.startsWith(prefix)) {
      base64 = base64.slice(prefix.length);
    }

    const byteCharacters = atob(base64);
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    return new Blob([byteNumbers], { type });
  };

  const formatImageName = (inputString) => {
    // Use a regular expression to remove everything before 'rs/'
    return inputString
      .replace(/.*\/rs\//, '') // Remove everything before 'rs/'
      .replace(/\//g, '-'); // Replace all forward slashes with hyphens
  };

  const updateReportStatus = async (selectedHTML, status, comment, updatedImpressions, buttonClick=false) => {
    console.log('****************** buttonClick', buttonClick);
    const currentUrl = window.location.href;
    const currUrl = new URL(currentUrl);
    const searchParams = new URLSearchParams(currUrl.search);
    const studyInstanceUID = searchParams.get('StudyInstanceUIDs');

    const commentId = document.getElementById('comment');
    const impressionId = document.getElementById('impression');


    let imgUrls = [];

    const formData = new FormData();
    reportImageSelector?.selectedImages?.forEach(({ imgName, imgData }) => {
      const prefix = 'data:image/png;base64,';
      if (imgData.startsWith(prefix)) {
        const formatedImageName = formatImageName(imgName);
        const blobImg = base64ToBlob(imgData);
        formData.append('file', blobImg, `${formatedImageName}.png`);
      }
      else {
        imgUrls.push(imgData);
      }
    })

    try {
      const response = await dispatch(uploadReportImgs(formData));

      if (response?.meta?.requestStatus === 'fulfilled') {

        if (response?.payload?.status === 'SUCCESS') {
          imgUrls = [...imgUrls, ...response?.payload?.results?.map((item) => {
            return item?.result;
          })]
        }

      } else {
        console.error('API request failed:', response.error); // Handle failure
      }
    } catch (error) {
      console.error('Error in dispatch:', error); // Handle any dispatch errors
    }
    const pacs_token = getCloudPACSToken();
    const patientStudyDetails = await fetch(
      `${PACS_URL}/dcm4chee-arc/aets/DCM4CHEE/rs/studies/${studyInstanceUID}/series?limit=21&includefield=all&offset=0&orderby=SeriesNumber`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${pacs_token}`
        },
      }
    );
    const data = await patientStudyDetails.json();

    const patientName = data?.map(item => item['00100010']?.Value?.[0])[0]?.Alphabetic;
    const patientGender = data?.map(item => item['00100040']?.Value?.[0])[0];
    const patientID = data?.map(item => item['00100020']?.Value?.[0])[0];
    const patientDOB = data?.map(item => item['00100030']?.Value?.[0])[0];

    const patientAge = patientDOB ? calculateAge(patientDOB) : 'N/A';
    const SNNumber = data?.map(item => item["00080050"]?.Value?.[0])[0]
    let gender = patientGender == 'M' ? 'Male' : patientGender == 'F' ? 'Female' : 'Other'

    const now = Date.now();
    const currentDate = new Date(now);
    // Get the date in YYYY-MM-DD format
    const date = currentDate.toISOString().split('T')[0];

    // Get the time in HH:MM:SS format
    const time = currentDate.toTimeString().split(' ')[0];
    const payload = {
      htmlTemplate: selectedHTML,
      editorMode: selectedTempleate?.editorMode,
      patientName,
      patientGender: gender,
      reportName: selectedTemplateName,
      patientAge,
      patientID: SNNumber,
      uhid: patientID,
      date,
      time,
      studyInstanceUID,
      status: status,//status.value,
      images: imgUrls,
      modality: selectedTempleate?.modality,
      comment: commentId?.value || comment,
      impressions: impressionId?.value || impressions,
      templateId: templateID,
    };
    if (actionType === 'view') {
      payload['templateId'] = selectedTempleate?.templateId;
    }
    if (reportId || currentReportId) {
      payload["_id"] = reportId || currentReportId
    }
    try {
      const response = await createNewReport(payload);
      setCurrentReportId(response?.result?.id)

      if (response.status == 'SUCCESS') {
        if(buttonClick){
          setModal(true);
        } else {
          uiNotificationService.show({
            title: 'Success',
            message:
              response?.msg || "Report created successfully",
            type: 'success',
            duration: 3000,
            position: 'topRight',
          });
        }
        if(!isSharedLink){
          setTimeout(() => {
            if (status === 'Authorized') {
              navigate(`/report/preview/${reportId || currentReportId}`)
            }
            else {
              if(buttonClick){
                navigate("/reportlist")
              }
            }
          }, 2000);
        }
      }
      else {
        uiNotificationService.show({
          title: '',
          message:
            response?.msg || "Error occured",
          type: 'error',
          duration: 3000,
          position: 'topRight',
        });
        if (response?.msg === 'Add signature first then authorized') {
          const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
          const roleRedirectMap = {
            'teleRadiology': '/editTeleradiology',
            'Radiologist': `/user/details/${userId}`,
            'hospitalsuperadmin': '/edithospital',
            'Admin': `/user/details/${userId}`,
            'Front Desk': `/user/details/${userId}`,
            'Nurse': `/user/details/${userId}`,
            'Resident': `/user/details/${userId}`,
            'Clinician': `/user/details/${userId}`,
            [_roleType.technician]: `/user/details/${userId}`,
            [_roleType.pathologist]: `/user/details/${userId}`,
          };
          const redirectUrl = roleRedirectMap[role];
          if (redirectUrl) {
            navigate(redirectUrl);
          }
        }
      }
    } catch (err) {

    }
  }

  const handleConfirm = () => {
    if (isPathology) {
      createPathologyReport(reportData, selectedReportStatus, comment, true);
    } else {
      updateReportStatus(reportData, selectedReportStatus, comment, true);
    }
    setAuthorizedPopup(false)
    // const whatsappNumber = `${9120876547}`;
    // const reportData = {
    //     reportId: "c8a40a1d12c238558201c144271d6804",
    //     reportNumber: "REP2410100014",
    //     phoneNumber: whatsappNumber
    // };

    // dispatch(shareReportWhatsapp(reportData));

  }
  const handleCancel = () => {
    setAuthorizedPopup(false)
  }

  function calculateAge(birthdate) {
    const year = parseInt(birthdate.substring(0, 4), 10);
    const month = parseInt(birthdate.substring(4, 6), 10) - 1; // Months are 0-based in JS
    const day = parseInt(birthdate.substring(6, 8), 10);

    // Create a Date object for the birthdate
    const birthDate = new Date(year, month, day);

    // Get the current date
    const currentDate = new Date();

    // Calculate the age
    let age = currentDate.getFullYear() - birthDate.getFullYear();

    // Adjust if the birthdate hasn't occurred yet this year
    const isBirthdayPassed =
      currentDate.getMonth() > birthDate.getMonth() ||
      (currentDate.getMonth() === birthDate.getMonth() &&
        currentDate.getDate() >= birthDate.getDate());

    if (!isBirthdayPassed) {
      age--;
    }

    return age;
  }

  const [currentReport, setCurrentReport] = useState(null)
  const [CurrentReportPriority, setCurrentReportPriority] = useState("")
  const [SelectedReportPriority, setSelectedReportPriority] = useState("")
  const [speechToTextAvailable, setSpeechToTextAvailable] = useState(false)

  const getCurrReport = async (): Promise<boolean> => {
    let payload;
    if (!isPathology) {
      const currentUrl = window.location.href;
      const currUrl = new URL(currentUrl);
      const searchParams = new URLSearchParams(currUrl.search);
      const studyInstanceUID = searchParams.get('StudyInstanceUIDs');
      payload = { studyInstanceUID };
    } else {
      //unique id of WSI image
      const url = window.location.href;
      const segments = new URL(url).pathname.split('/');
      const extractedValue = segments[segments.length - 1]; // Get the last segment
      payload = { wsiID: extractedValue };
    }

    //const payload = { studyInstanceUID }

    try {
      const response = await getCurrentReport(payload);
      if (!response.ok) {
        setCurrentReport(response?.result)
        setCurrentReportPriority(response?.result?.priority);
        // Sync dropdown selected value with backend priority
        setSelectedReportPriority(response?.result?.priority || "");
        setCurrentReportImageLink(response?.result?.images)
        setPatientID(response?.result?.patientId);
        setReportID(response?.result?._id);
        setPatientName(response?.result?.name);
          // Also update local status state for immediate UI refresh
          if (response?.result?.status) {
            const formattedStatus = capitalizeWords(response?.result?.status);
            setStatus({
              label: formattedStatus,
              value: formattedStatus
            });
          }
          return true;
      }
    } catch (error) {

    }
  }

  useEffect(() => {
    getCurrReport()

    // Check speech to text availability
    const checkSpeechToTextAvailability = async () => {
      try {
        const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
        const [hospitalDetail, userDetail] = await Promise.all([
          dispatch(hospitalDetailApi({ hospitalId })).unwrap(),
          dispatch(userDetails()).unwrap()
        ]);
        setSpeechToTextAvailable(
          hospitalDetail?.result?.addOnsAvailable?.speechToText === true &&
          userDetail?.result?.speechToText === true
        );
      } catch (err) {
        console.error("Error in checkSpeechToTextService", err);
        setSpeechToTextAvailable(false);
      }
    };

    checkSpeechToTextAvailability();
  }, []);

  // Ref flag to avoid concurrent polling intervals
  const pollingRef = useRef<boolean>(false);

  // Listen for auto-save complete events to refresh the current report details
  useEffect(() => {
    const handleAutoSaved = async () => {
      if (pollingRef.current) return;

      pollingRef.current = true;
      let retries = 0;
      const maxRetries = 5;
      const retryDelay = 1000; // 1 second

      const poll = async () => {
        try {
          const found = await getCurrReport();
          if (found || retries >= maxRetries) {
            // Dispatch event when polling completes
            window.dispatchEvent(new CustomEvent('report-sync-complete', {
              detail: { success: found, retries }
            }));
            pollingRef.current = false;
            return;
          }

          retries++;
          setTimeout(poll, retryDelay);
        } catch (error) {
          console.error('Error during report sync:', error);
          pollingRef.current = false;
        }
      };

      poll();
    };

    window.addEventListener('report-autosaved', handleAutoSaved);
    return () => window.removeEventListener('report-autosaved', handleAutoSaved);
  }, [getCurrReport]);

  const checkPermissionByRole = () => {
    const role = sessionStorage.getItem('role') || localStorage.getItem('role');
    if (role === _roleType.pathologist || role === _roleType.radiologist || role === _roleType.hospitalSuperadmin || role === _roleType.admin) {
      return true;
    } else {
      return false;
    }
  }

  const handleRedo = () => {
    setIsPopupRedoOpen(true);
  };

  useEffect(() => {
    const handleSuccess = message => {
      setDisplayMessage(message);
      setIsSuccessModalOpen(true);
      setTimeout(() => {
        setIsSuccessModalOpen(false);
        navigate('/appointments');
      }, 1500);
    };
    if (addRedoReasonData?.status === 'SUCCESS') {
      handleSuccess('Reason added successfully.');
    }
    if (redoScanData?.status === 'SUCCESS' && !isRedoReasonCalled) {
      setIsRedoReasonCalled(true);
      dispatch(addRedoReason({ reportId: reportID, redoReason: reason }));
    }

    return () => {
      setIsRedoLoading(false);
      dispatch(closeModal());
      dispatch(redoCloseModal());
    };
  }, [addRedoReasonData?.status, redoScanData?.status, isRedoReasonCalled, dispatch]);

  const handleRedoConfirm = async () => {
    if (!reason.trim()) {
      setErrorMessage('Reason is required for redo scan.');
      uiNotificationService.show({
        title: 'Validation Error',
        message: 'Please provide a reason for the redo scan.',
        type: 'error',
        position: 'topRight',
      });
      return;
    }
    setIsPopupRedoOpen(false);
    setIsRedoLoading(true);
    const payload = { status: 'Redo' };
    await dispatch(redoScan({ patientID, payload }));
    await handleConfirmDelete();
  };

  const handleConfirmDelete = async () => {
    const pacsToken = getCloudPACSToken();
    const currentUrl = window.location.href;
    const currUrl = new URL(currentUrl);
    const searchParams = new URLSearchParams(currUrl.search);
    const studyInstanceUID = searchParams.get('StudyInstanceUIDs');
    try {
      const fetchPromises =
        fetch(_deleteDicomUrl(studyInstanceUID), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${pacsToken}`,
          },
        });

      const responses = await fetchPromises;

      if (!responses.ok) {
        throw new Error(
          `Failed to fetch some files. Statuses: ${responses.status}`
        );
      }

      uiNotificationService.show({
        title: "Success",
        message: "All files deleted successfully",
        type: "success",
        duration: 3000,
        position: "topRight",
      })

      navigate('/');
    } catch (error) {
      console.log(error)
      uiNotificationService.show({
        title: "Error",
        message: `Failed to delete files: ${error.message}`,
        type: "error",
        duration: 3000,
        position: "topRight",
      })
    }
  }

  const handleRedoCancel = () => {
    setReason('');
    setErrorMessage('');
    setIsPopupRedoOpen(false);
  };

  const priorityOptions = [
    {
      value: "Critical",
      label: "Critical"
    },
    {
      value: "Priority",
      label: "Priority"
    },
    {
      value: "Routine",
      label: "Routine"
    }
  ]

  useEffect(() => {
    if (SelectedReportPriority) {
      changeReportPriortityStatus();
    }
  }, [SelectedReportPriority])

  const changeReportPriortityStatus = async () => {
    const Payload = {
      id: currentReport?._id,
      priority: SelectedReportPriority
    }
    try {
      const response = await changeReportPriority(Payload)
      if (!response.ok) {
        getCurrReport();
      }
    } catch (error) {
      console.log(error, "error")
    }
  }

  return (
    <>
      <div
        className="border-primary-light relative mt-[2px] box-border cursor-ew-resize overflow-scroll rounded border-2 bg-white p-6 customReportLayoutMob"
        style={{ width: `${width}px`, maxWidth: '700px', minWidth: '300px', overflow: 'scroll' }}>
        {
          !isPathology &&
          <div
            className="hover:bg-primary-600 absolute top-0 left-0 h-full w-2 cursor-ew-resize"
            style={{ cursor: 'ew-resize' }}
            onMouseDown={handleMouseDown}></div>
        }

        <div>
          <div className="flex items-end justify-between customReportLayoutMobHeader">
            <h2 className="text-primary-light">
              {selectedTemplateName}
              <br />
              <span style={{ color: "#000000" }}>
                {status?.value ? "Status: " : ""}
                {status?.value}
              </span>
            </h2>
            {
              !isPathology &&
              <div className="form__Field flex items-center gap-2" >
                <label className="form__label mt-0 mb-0" style={{ color: "#000000", minWidth: "80px", marginBottom: "0px" }}>
                  Case Study:
                </label>
                <select
                  className="form__select form__select--sm"
                  style={{ width: "140px", paddingTop: "5px", paddingBottom: "5px", height: "30px" }}
                  id="priority"
                  name="priority"
                  onChange={(e) => {
                    setSelectedReportPriority(e.target.value);
                  }}
                  value={SelectedReportPriority ? SelectedReportPriority : CurrentReportPriority}
                  autoComplete='off'
                >
                  <option value="">-Select-</option>
                  {priorityOptions?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            }
             {!window.location.href.includes('WSI') && (actionType === 'view' || currentReport?._id) && (
              <button className='btn btn__primary' style={{ height: '35px' }} onClick={handleRedo}>Redo Study</button>
            )}
          </div>

          {checkPermissionByRole() && speechToTextAvailable && reportStatus !== _reportStatus.Authorized && <SpeechToText contentDiv="content-edit" />}
          <div id="content-edit" className='customReportLayoutMobContentEdit'>
            <RichTextEditor
              editorMode={selectedTempleate?.editorMode}
              selectedItem={selectedTempleate}
              retractable={true}
              setSelectedTempleate={setSelectedTempleate}
              handleCreateReport={handleCreateReport}
              setOpenReportPanel={setOpenReportPanel}
              reportStatus={status?.value}
              reportId={reportId}
              currentReportId={currentReportId}
              findingsProp={selectedTempleate?.findings}
              impressionsProp={selectedTempleate?.impressions}
              isPathology={isPathology}
              setImpressions={setImpressions}
            />
          </div>

        </div>
      </div>
      <Loader isLoaderOpen={isLoading || isRedoLoading} />

      {
        modal && <SuccessModal
          isSuccessModalOpen={modal}
          title={`Report ${status.label === "Draft" ? "drafted" : status.label === "Completed" ? "completed" : status.label === "Authorized" ? "authorized" : status} successfully.`}
          handleCloseModal={() => setModal(false)}
        />
      }

      <ConfirmationPopup
        isOpen={isPopupOpen}
        title="Authorized Report"
        message={`Are you sure you want Authorize this report?`}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <ConfirmationPopup
        isOpen={isPopupRedoOpen}
        title="Reason for Redo Scan"
        onConfirm={handleRedoConfirm}
        onCancel={handleRedoCancel}
        deleteMessage="Your study & report will be deleted."
        textField={
          <div className="w-full">
          <input
            type="text"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Reason"
            className="textfield w-full"
          />
            {errorMessage && (
              <p className="text-red-500 text-base mt-1">
                {errorMessage}
              </p>
            )}
          </div>
        }
      />
    </>
  );
};


export const SuccessModalconfrim = ({ handleCloseModal, title }) => {
  setTimeout(() => {
    handleCloseModal(); // Call your function to close the modal
  }, 1500)
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '250px',
          width: '400px', // Set a width for the modal
          textAlign: 'center',
          borderRadius: '32px',
          padding: '20px 10px 20px 10px',
          position: 'fixed', // Use fixed position to center it on the screen
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)', // Center the modal
          backgroundColor: 'white', // Add background color to the modal
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', // Optional: add a shadow for better visibility
          zIndex: 1000, // Ensure the modal is above other elements
        }}
      >
        <Icon
          name="SuccessCircle"
          className="text-black cursor-pointer"
        />
        <p style={{
          fontFamily: 'Poppins, sans-serif',
          fontSize: '23.14px',
          fontWeight: 600,
          lineHeight: '34.71px',
          color: 'black',
          padding: '20px',
        }}>
          {title}
        </p>
      </div>
    </>
  )
}


export default ReportLayout;
